import apiService from '../service/ApiService';
import { INTERNAL_ROUTES } from '../static/Urls';

const userInfoApiUrl = INTERNAL_ROUTES.API_PATH + '/api/userinfo';

const fetchUserInfo = (): Promise<unknown> => {
  return apiService.callGet<unknown>(userInfoApiUrl, { withCredentials: true }, undefined, {
    doOnError: () => null,
    doReturn: () => Promise.resolve('unauthorized'),
  });
};

const userInfoApi = {
  fetch: fetchUserInfo,
};

export default userInfoApi;
